"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSpeciesDetail = exports.mockSpecies = exports.SPECIES_NAME_SMALLMOUTH = exports.SPECIES_NAME_LARGEMOUTH = exports.SPECIES_ALL_NAME = void 0;
exports.SPECIES_ALL_NAME = 'all';
exports.SPECIES_NAME_LARGEMOUTH = 'largemouth_bass';
exports.SPECIES_NAME_SMALLMOUTH = 'smallmouth_bass';
function mockSpecies(overrides = {}) {
    return {
        banner_image: 'http://example.com/banner.jpg',
        color: '#ff0000',
        description: 'mock description',
        display_name: 'mock display_name',
        display_order: 1,
        id: 1,
        image: 'http://example.com/walleye.jpg',
        img_alt: 'mock img_alt',
        meta_description: 'mock meta_description',
        meta_title: 'mock meta_title',
        name: 'mock name',
        page_heading: 'mock page_heading',
        page_subheading: 'mock page_subheading',
        recommendations_order: 1,
        url_path: 'mock_url_path',
        ...overrides,
    };
}
exports.mockSpecies = mockSpecies;
function mockSpeciesDetail(overrides = {}) {
    const { ambassador_lists, links, ...speciesOverrides } = overrides;
    const detailOverrides = {
        ambassador_lists,
        links,
    };
    return {
        ...mockSpecies(speciesOverrides),
        ambassador_lists: [],
        links: [],
        ...detailOverrides,
    };
}
exports.mockSpeciesDetail = mockSpeciesDetail;
